import React from 'react';
import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuth from '../Login/useAuth';
import BookingModal from './BookingModal';
import './Booking.css'
const Booking = ({ b, date, setSuccess }) => {

    const { user } = useAuth()
    const handleShow = () => setPhone(true);
    const [open, setPhone] = useState(false);
    const handleClose = () => setPhone(false);
    const { name, time, space, price, comapnyName, img } = b
    return (
        <>
            <div  className="col-md-6 col-lg-4 col-sm-6 car">
                <Card
                 data-aos="flip-left"
                 data-aos-easing="ease-out-cubic"
                 data-aos-duration="3000"
                className='car mb-2 mx-3 justify-content-center align-items-center  ms-2' style={{ width: '15rem' }}>
                    <Card.Img variant="top" className='w-50 h-50' src={img} />
                    <Card.Body className='text-start'>
                        <Card.Title className='text-white '>{name}</Card.Title>
                        <h6 className='word-wrap fw-normal'>
                            schedule: {time}
                        </h6>

                        <h5 className='word-wrap fw-normal'>
                            Made In: {comapnyName}
                        </h5>
                        <h5 className='word-wrap fw-normal'>
                            Price:  ${price}
                        </h5>
                        <h5 className='fw-bold'>
                            {space} SPACES AVAILABLE
                        </h5>
                        <div className="text-center">
                            {user?.email ? <Button variant="dark" onClick={handleShow}>
                                Order Now
                            </Button> : <Link className=' btn btn-dark btn-sm  text-decoration-none fs-5' to='/login'>Order Now</Link>
                            }
                        </div>
                    </Card.Body>
                </Card>
            </div>
            <BookingModal
                b={b}
                date={date}
                setSuccess={setSuccess}
                open={open}
                handleClose={handleClose}
            ></BookingModal>
        </>
    );
};

export default Booking;